import { render, staticRenderFns } from "./completeToDoItemDialog.vue?vue&type=template&id=5e99b08b&scoped=true"
import script from "./completeToDoItemDialog.vue?vue&type=script&lang=ts"
export * from "./completeToDoItemDialog.vue?vue&type=script&lang=ts"
import style0 from "./completeToDoItemDialog.vue?vue&type=style&index=0&id=5e99b08b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e99b08b",
  null
  
)

export default component.exports